import { initialVaultTransactionsTable, initialRecipientsDrillDown } from "./helper";
import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";

const initialState = {
    vaultTransactionsTable: initialVaultTransactionsTable,
    recipientsDrillDown: initialRecipientsDrillDown,
    revoke: { loading: false },
};

const setTable = (state, action) => updateObject(state, {
    vaultTransactionsTable: updateObject(state.vaultTransactionsTable, { [action.key]: action.value }),
});

const setDrillDown = (state, action) => updateObject(state, {
    recipientsDrillDown: updateObject(state.recipientsDrillDown, { [action.key]: action.value }),
});

const setRevoke = (state, action) => updateObject(state, {
    revoke: updateObject(state.revoke, { [action.key]: action.value }),
});

const vaultTransactionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_VAULT_TRANSACTIONS:
            return setTable(state, action);
        case actionTypes.GET_VAULT_TRANSACTION_RECIPIENTS:
            return setDrillDown(state, action);
        case actionTypes.REVOKE_VAULT_TRANSACTION:
            return setRevoke(state, action);
        default:
            return state;
    }
};

export default vaultTransactionsReducer;
